/*=========================================================================================
  File Name: moduleDocumentUpload.js
  Description: DocumentUpload Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleDocumentUploadState.js';
import mutations from './moduleDocumentUploadMutation';
import actions from './moduleDocumentUploadAction';
import getters from './moduleDocumentUploadGetter';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
